(function () {
  'use strict';
  if (!document.querySelector('.cria-lp-root')) return;

const nav = document.getElementById('nav');
  window.addEventListener('scroll', () => nav.classList.toggle('scrolled', window.scrollY > 40));

  // subscription dropdown ("Assinatura")
  const dropdown = document.getElementById('assinaturaDropdown');
  const dropdownTrigger = document.getElementById('assinaturaTrigger');
  dropdownTrigger.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdown.classList.toggle('open');
  });
  document.addEventListener('click', (e) => {
    if(!dropdown.contains(e.target)) dropdown.classList.remove('open');
  });
  dropdown.querySelectorAll('a').forEach(a => a.addEventListener('click', () => dropdown.classList.remove('open')));

  // hero video mute toggle (native HTML5 video)
  const heroVideo = document.getElementById('heroVideo');
  const muteBtn = document.getElementById('muteBtn');
  const muteIcon = document.getElementById('muteIcon');
  muteBtn.addEventListener('click', () => {
    heroVideo.muted = !heroVideo.muted;
    muteIcon.innerHTML = heroVideo.muted
      ? '<path d="M11 5L6 9H3V15H6L11 19V5Z" stroke="#0c0b0a" stroke-width="1.6" stroke-linejoin="round"/><path d="M17 9C18.5 10.5 18.5 13.5 17 15" stroke="#0c0b0a" stroke-width="1.6" stroke-linecap="round"/><line x1="15.5" y1="6" x2="21" y2="18" stroke="#0c0b0a" stroke-width="1.6" stroke-linecap="round"/>'
      : '<path d="M11 5L6 9H3V15H6L11 19V5Z" stroke="#0c0b0a" stroke-width="1.6" stroke-linejoin="round"/><path d="M15 9C16.5 10.5 16.5 13.5 15 15" stroke="#0c0b0a" stroke-width="1.6" stroke-linecap="round"/><path d="M17.5 7C20 9.5 20 14.5 17.5 17" stroke="#0c0b0a" stroke-width="1.6" stroke-linecap="round"/>';
  });

  const revealEls = document.querySelectorAll('.reveal');
  // stagger cards that share a parent (feature/condition/testimonial grids) so they
  // cascade in one after another as the group scrolls into view, instead of popping in at once
  const groups = new Map();
  revealEls.forEach(el => {
    const parent = el.parentElement;
    if(!groups.has(parent)) groups.set(parent, []);
    groups.get(parent).push(el);
  });
  groups.forEach(siblings => {
    if(siblings.length > 1){
      siblings.forEach((el, i) => { el.style.transitionDelay = (i * 0.09) + 's'; });
    }
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if(e.isIntersecting){
        e.target.classList.add('in');
        io.unobserve(e.target);
        // clear the stagger delay once the entrance transition has run its course,
        // so it doesn't linger and affect later hover transitions (background/color etc.)
        const delayMs = parseFloat(e.target.style.transitionDelay || '0') * 1000;
        setTimeout(() => { e.target.style.transitionDelay = ''; }, delayMs + 800);
      }
    });
  }, {threshold:0.12});
  revealEls.forEach(el => io.observe(el));

  const brands = ['Royal Canin','GranPlus','BioFresh','Guabi Natural','PremieR','N&D','VetLife','Golden'];
  const marquee = document.getElementById('marquee');
  marquee.innerHTML = [...brands, ...brands, ...brands, ...brands].map(b => `<span>${b}</span>`).join('<span style="opacity:.3">&nbsp;&nbsp;•&nbsp;&nbsp;</span>');

  const track = document.getElementById('sliderTrack');
  const fill = document.getElementById('sliderFill');
  const handle = document.getElementById('sliderHandle');
  const weightNum = document.getElementById('weightNum');
  const resFull = document.getElementById('resFull');
  const resPrice = document.getElementById('resPrice');
  const resSaving = document.getElementById('resSaving');
  const racaoSelect = document.getElementById('racaoSelect');
  const MIN = 1, MAX = 10;
  let value = 5;
  const root = document.querySelector('.cria-lp-root');
  const CLUB_DISCOUNT = (parseFloat(root && root.dataset.clubDiscount) || 10) / 100;

  function render(){
    const pct = (value - MIN) / (MAX - MIN);
    fill.style.width = (pct*100) + '%';
    handle.style.left = (pct*100) + '%';
    weightNum.textContent = value;
    handle.setAttribute('aria-valuenow', value);

    const pricePer100g = parseFloat(racaoSelect.value);
    const fullPrice = value * 10 * pricePer100g; // 1kg = 10 unidades de 100g
    const memberPrice = fullPrice * (1 - CLUB_DISCOUNT);
    const yearlySaving = (fullPrice - memberPrice) * 12;

    resFull.textContent = 'R$ ' + fullPrice.toFixed(0);
    resPrice.textContent = 'R$ ' + memberPrice.toFixed(0);
    resSaving.textContent = 'R$ ' + yearlySaving.toFixed(0);
  }
  racaoSelect.addEventListener('change', render);
  function setFromClientX(clientX){
    const rect = track.getBoundingClientRect();
    let pct = (clientX - rect.left) / rect.width;
    pct = Math.min(1, Math.max(0, pct));
    value = Math.round(MIN + pct * (MAX - MIN));
    render();
  }
  let dragging = false;
  handle.addEventListener('pointerdown', (e) => { dragging = true; handle.setPointerCapture(e.pointerId); });
  window.addEventListener('pointermove', (e) => { if(dragging) setFromClientX(e.clientX); });
  window.addEventListener('pointerup', () => dragging = false);
  track.addEventListener('pointerdown', (e) => { setFromClientX(e.clientX); dragging = true; });
  handle.addEventListener('keydown', (e) => {
    if(e.key === 'ArrowRight'){ value = Math.min(MAX, value+1); render(); }
    if(e.key === 'ArrowLeft'){ value = Math.max(MIN, value-1); render(); }
  });
  render();

  document.querySelectorAll('.faq-item').forEach(item => {
    const q = item.querySelector('.faq-q');
    const a = item.querySelector('.faq-a');
    if(item.classList.contains('open')){ a.style.maxHeight = a.scrollHeight + 'px'; }
    q.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(o => {
        if(o !== item){ o.classList.remove('open'); o.querySelector('.faq-a').style.maxHeight = null; }
      });
      item.classList.toggle('open', !isOpen);
      a.style.maxHeight = !isOpen ? a.scrollHeight + 'px' : null;
    });
  });

  // ---- parallax on scroll ----
  const parallaxEls = [...document.querySelectorAll('[data-parallax]')].map(el => ({
    el, speed: parseFloat(el.dataset.parallax)
  }));
  let ticking = false;
  function updateParallax(){
    const vh = window.innerHeight;
    parallaxEls.forEach(({el, speed}) => {
      const rect = el.parentElement.getBoundingClientRect();
      const center = rect.top + rect.height / 2;
      const offset = (center - vh / 2) * speed;
      el.style.transform = `translateY(${offset}px)`;
    });
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if(!ticking){ requestAnimationFrame(updateParallax); ticking = true; }
  }, {passive:true});
  updateParallax();

  // subtle depth: hero text drifts slightly slower than the video underneath it
  const heroContent = document.querySelector('.hero-content');
  window.addEventListener('scroll', () => {
    if(heroContent && window.scrollY < window.innerHeight){
      heroContent.style.transform = `translateY(${window.scrollY * 0.18}px)`;
      heroContent.style.opacity = 1 - (window.scrollY / (window.innerHeight * 0.9));
    }
  }, {passive:true});
})();
